<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="所属用户"
        ><BusinessLookupSelect v-model="query.userId" type="users" placeholder="请选择用户"
      /></el-form-item>
      <el-form-item label="来源">
        <el-select v-model="query.sourceType" clearable class="!w-140px">
          <el-option v-for="item in sourceTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-140px">
          <el-option
            v-for="(label, value) in statusLabels"
            :key="value"
            :label="label"
            :value="Number(value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search">查询</el-button>
    </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="requestNo" label="请求号" min-width="160" />
      <el-table-column label="所属用户" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.userId" /></template></el-table-column>
      <el-table-column prop="sourceType" label="来源" width="110" />
      <el-table-column prop="summary" label="情报摘要" min-width="220" show-overflow-tooltip />
      <el-table-column label="状态" width="100">
        <template #default="scope">{{ statusLabels[scope.row.status] || '未知' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" />
      <el-table-column label="操作" width="140">
        <template #default="scope">
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <el-button
            v-if="scope.row.status === 1"
            v-hasPermi="['bosscircle:intel-brief:manage']"
            link
            type="warning"
            @click="ignore(scope.row)"
            >忽略</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="商机情报详情" width="800px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="请求号">{{ detail.requestNo }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabels[detail.status] }}</el-descriptions-item>
      <el-descriptions-item label="所属用户">{{ detail.userId }}</el-descriptions-item>
      <el-descriptions-item label="来源"
        >{{ detail.sourceType }} / {{ detail.sourceId }}</el-descriptions-item
      >
      <el-descriptions-item label="来源摘要" :span="2">{{
        detail.sourceSnapshot || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="情报摘要" :span="2">{{
        detail.summary || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="行动建议" :span="2">{{
        detail.actionJson || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="推进舱ID">{{ detail.dealRoomId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="处理时间">{{ detail.handledAt || '-' }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import * as IntelBriefApi from '@/api/business/intelBrief'

defineOptions({ name: 'BossCircleIntelBrief' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const timeRange = ref<string[]>([])
const detailVisible = ref(false)
const detail = ref<any>()
const sourceTypes = ['NEWS', 'FEED', 'BIZ_OPP', 'ACTIVITY']
const statusLabels: Record<number, string> = {
  0: '生成中',
  1: '待处理',
  2: '已忽略',
  3: '已转推进',
  4: '失败'
}
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined,
  sourceType: undefined,
  status: undefined
})
const load = async () => {
  loading.value = true
  try {
    const data = await IntelBriefApi.getIntelBriefPage({
      ...query,
      beginTime: timeRange.value?.[0],
      endTime: timeRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openDetail = async (id: number) => {
  detail.value = await IntelBriefApi.getIntelBrief(id)
  detailVisible.value = true
}
const ignore = async (row: any) => {
  await message.confirm('确认忽略该条商机情报吗？')
  await IntelBriefApi.ignoreIntelBrief({ id: row.id, version: row.version })
  message.success('已忽略')
  await load()
}
onMounted(load)
</script>
